import { withSignedInPortalRedirect } from "~/utils/signed-in-portal-redirect";
import { SignUpV3View } from "~auth/views/sign-up-v3";
import { RedirectToPortal } from "~auth/hoc/redirect-to-portal";
import { SignUpV4View } from "~auth/views/sign-up-v4";
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import type { NextPage } from "next";
import { NextSeo } from "next-seo";
import { useEffect } from "react";
import { sendSignUpPageViewEvent } from "~tag-manager/send-event";
import {
	getSignupGeneration,
	type SignupGeneration,
} from "../src/server/signup-generation";

interface SignUpPageProps {
	generation: SignupGeneration | null;
}

export const SignUpExperience = ({ generation }: SignUpPageProps) => (
	<RedirectToPortal>
		{generation === "v3" ? <SignUpV3View /> : null}
		{generation === "v4" ? <SignUpV4View /> : null}
		{generation === null ? (
			<Container
				maxWidth="sm"
				sx={{ py: 8 }}>
				<Alert severity="warning">
					Signup is temporarily unavailable. Please try again shortly.
				</Alert>
			</Container>
		) : null}
	</RedirectToPortal>
);

const SignUpPage: NextPage<SignUpPageProps> = ({ generation }) => {
	useEffect(() => {
		sendSignUpPageViewEvent();
	}, []);

	return (
		<>
			<NextSeo
				title="Sign up"
				description="Start mapping for free with our no-obligation free trial."
				canonical="https://mangomap.com/sign-up"
				openGraph={{
					title: "Sign up",
					description:
						"Start mapping for free with our no-obligation free trial.",
					url: "https://mangomap.com/sign-up",
					site_name: "Mango GIS",
				}}
			/>
			<SignUpExperience generation={generation} />
		</>
	);
};

export const getServerSideProps = withSignedInPortalRedirect<SignUpPageProps>(
	async ({ res }) => {
		try {
			return { props: { generation: await getSignupGeneration() } };
		} catch (error) {
			console.error("Failed to resolve runtime signup generation", error);
			res.statusCode = 503;
			return { props: { generation: null } };
		}
	},
);

export default SignUpPage;
